export const Brand = () => (
  <div className="dm-brand">
    <div className="dm-mark" aria-hidden="true">
      D
    </div>
    <div>
      <strong>DevMil</strong>
      <span>Instagram Control</span>
    </div>
  </div>
);
